export const FETCH_PRODUCTS = "PRODUCTS/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_SUCCESS = "PRODUCTS/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "PRODUCTS/FETCH_PRODUCTS_FAILURE";

export const GET_PRODUCT = 'PRODUCTS/GET_PRODUCT';
export const GET_PRODUCT_SUCCESS = 'PRODUCTS/GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAILURE = 'PRODUCTS/GET_PRODUCT_FAILURE';

export const EDIT_PRODUCT = 'PRODUCTS/EDIT_PRODUCT';
export const EDIT_PRODUCT_SUCCESS = 'PRODUCTS/EDIT_PRODUCT_SUCCESS';
export const EDIT_PRODUCT_FAILURE = 'PRODUCTS/EDIT_PRODUCT_FAILURE';

export const CLEAR_PRODUCT = 'PRODUCTS/CLEAR_PRODUCT';
export const CLEAR_FILTER_VALUES = 'PRODUCTS/CLEAR_FILTER_VALUES';

export const SET_FITER_VALUES = 'PRODUCTS/SET_FITER_VALUES';
export const SET_SEARCH_VALUE = 'PRODUCTS/SET_SEARCH_VALUE';

export const GET_CATEGORIES = 'PRODUCTS/GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'PRODUCTS/GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'PRODUCTS/GET_CATEGORIES_FAILURE';

export const UPLOAD_TEMPLATE = 'PRODUCTS/UPLOAD_TEMPLATE';
export const UPLOAD_TEMPLATE_SUCCESS = 'PRODUCTS/UPLOAD_TEMPLATE_SUCCESS';
export const UPLOAD_TEMPLATE_FAILURE = 'PRODUCTS/UPLOAD_TEMPLATE_FAILURE';
